import React, { PureComponent } from "react";
import { connect } from "react-redux";

import styles from "./BalanceSheet.local.scss";
import { initBalanceSheet, setBalanceSheetOrganization } from "Actions";
import BalanceSheet from "./BalanceSheet";
import { fetchBalanceSheet } from "Thunks";
import { selectRouting } from "../../selectors";
import { getEmbedWidthParam } from "../../utils";

class EmbeddedBalanceSheetPage extends PureComponent {
  constructor(props) {
    super(props);
    let { uen } = this.props.match.params;

    this.state = { organizationUen: uen };
  }

  componentDidMount() {
    const { dispatch, organization, currentOrganization } = this.props;
    const { organizationUen } = this.state;

    let { uen } = this.props.match.params;
    this.setState({ organizationUen: uen });

    if (!organization) {
      if (!organizationUen) {
        return false;
      }

      dispatch(fetchBalanceSheet(organizationUen));
    } else {
      if (organizationUen === currentOrganization.uen) {
        dispatch(setBalanceSheetOrganization(currentOrganization));
      }

      dispatch(initBalanceSheet());
      dispatch(fetchBalanceSheet(organizationUen));
    }
  }

  render() {
    const { fetching, routing } = this.props;

    const embedWidth = getEmbedWidthParam(routing.location) || "100%";
    return (
      <div className={`page-content`}>
        <div
          style={{
            width: embedWidth
          }}
        >
          {fetching && (
            <div className={styles.ripple_loading}>
              <img src={"/img/Ripple-1s-150px.svg"} alt="" />
            </div>
          )}
          <BalanceSheet uen={this.state.organizationUen} embedded={true} />
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetching: state.balanceSheet.fetching,
  fetched: state.balanceSheet.fetched,
  balanceSheet: state.balanceSheet,
  organization: state.balanceSheet.organization,
  subMenuDirection: state.params.subMenuDirection,
  currentOrganization: state.auth.currentOrganization,
  routing: selectRouting(state)
});

export default connect(mapStateToProps)(EmbeddedBalanceSheetPage);



// WEBPACK FOOTER //
// ./src/components/BalanceSheet/EmbeddedBalanceSheetPage.js